module.exports = __webpack_public_path__ + "img/ch07_03_闸机对话.52344397.jpg";